import angular from 'angular'
import angularOAuth2 from 'angular-oauth2'
import uiRouter from 'angular-ui-router'
import ngSanitize from 'angular-sanitize'
import myBookingApi from '../../../../../api/mybooking/mybooking'

import requestInvoiceComponent from './requestInvoice.component'

const RequestInvoiceModule = angular.module('requestInvoice', [
        uiRouter,
        angularOAuth2.name,
        ngSanitize,
        myBookingApi
    ])
    .config(($stateProvider) => {
        "ngInject";
        $stateProvider
            .state('bookings.booking.invoice.request', {
                url: '/request',
                views: {
                    'booking@bookings.booking': {
                        template: '<request-invoice></request-invoice>'
                    }
                }
            })
    })
    .component('requestInvoice', requestInvoiceComponent)
    .name;

export default RequestInvoiceModule


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/invoice/requestInvoice/requestInvoice.js